export default __webpack_public_path__ + "static/media/image-ph-study-report-n-w.1d8f21b5.png";